import Header from "../../components/Header/Header";
import Login from "../../components/Login/Login";
import Footer from "../../components/Footer/Footer";


export default function Home() {
  return (
    <>
        <Header />
        <Login permitirCadastro={false} apenasAdmin tituloLogin="Login do Administrador" />
        <Footer />
    </>
  );
}